import React from 'react';

import { IPUnitState } from 'features/systems/ip-unit/providers/states/ip-unit-provider-state';

const IPUnitProviderContext = React.createContext<IPUnitState>({} as never);

export default IPUnitProviderContext;
